import http from "@/api/http";
export default {
  getDetail(params){
    return http.get("/api/small-purchase-task-detail/detail","form",params);
  },
}
